import { render, staticRenderFns } from "./ModificarGiro.vue?vue&type=template&id=265e943e"
import script from "./ModificarGiro.vue?vue&type=script&lang=js"
export * from "./ModificarGiro.vue?vue&type=script&lang=js"
import style0 from "./ModificarGiro.vue?vue&type=style&index=0&id=265e943e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports